/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type React from 'react';
import {useEffect, useState} from 'react';
import {Form, Tab, Tabs, Button, InputGroup} from 'react-bootstrap';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import {useNavigate} from 'react-router-dom';

import LayoutMain from 'components/Layouts/LayoutMain';
import {useGetUsersCountQuery, useLazyGetUsersQuery} from 'services';
import type {ISubscriberProfile} from 'interfaces';
import {useAppSelector} from 'store/hooks';
import {RenderNoData} from 'components/RenderNoData';
import {RenderTabTitle} from 'components/RenderTabTitle';
import TableUsers from './TableUsers';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

TimeAgo.setDefaultLocale(en.locale);
TimeAgo.addLocale(en);

type TDataUsers = {
	type_search: string;
	valueOfFind: string;
	data: ISubscriberProfile | null;
};

const LIMIT = Number(process.env.REACT_APP_PAGINATE_LIMIT || 10);

const TIME_INTERVAL_MS = 59000;

export type TData = {
	selected: number;
};
const Users = () => {
	const navigate = useNavigate();
	const [getUsers, {isLoading: isLoadingUsers}] = useLazyGetUsersQuery();

	const [initialDate, setInitialDate] = useState<Date>(new Date());
	const [timeStr, setTimeStr] = useState<string>('just now');
	const [key, setKey] = useState<string>('Search Profile');
	const [dataUsers, setDataUsers] = useState<TDataUsers>({
		type_search: 'username',
		valueOfFind: '',
		data: null,
	});

	const [pageCount, setPageCount] = useState(0);
	const [page, setPage] = useState<number>(0);
	const {
		data: totalUsers = 0,
		isLoading: isLoadingCount,
		refetch: refetchCountUsers,
	} = useGetUsersCountQuery({like: dataUsers.valueOfFind, page});

	useEffect(
		() => setPageCount(Math.ceil((totalUsers as number) / LIMIT)),
		[totalUsers],
	);

	const timeAgo = new TimeAgo('en-US');

	const handlePage = (param: number) => setPage(param);

	const handlePageClick = async ({selected}: TData) => {
		const currentPage = selected;

		console.log(currentPage, 'currentPage');

		await handleRefetch(currentPage);
		handlePage(currentPage);
		setPageCount(Math.ceil((totalUsers as number) / LIMIT));
	};

	/**
	 * This function formats a given date as a string representing how long ago it was.
	 */
	const handleDateAgo = () => setTimeStr(timeAgo.format(initialDate));

	/* A custom hook that is used to update the time every 59 seconds. */
	useEffect(() => {
		const interval = setInterval(() => {
			handleDateAgo();
		}, TIME_INTERVAL_MS);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/* It's a hook that runs after the component is rendered. */
	useEffect(() => {
		setInitialDate(new Date());
		handleDateAgo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataUsers.data]);

	const changeValueOfFind = (
		e: React.ChangeEvent<HTMLInputElement>,
		type: string,
	) => {
		if (type === 'profile') {
			setDataUsers({...dataUsers, valueOfFind: e.target.value});
		}
	};

	const changeSelectOption = ({
		target,
	}: React.ChangeEvent<HTMLSelectElement>) => {
		const {value} = target;
		setDataUsers({...dataUsers, type_search: value});
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		try {
			const tmp =
				(await getUsers({like: dataUsers.valueOfFind, page}).unwrap()) || [];
			setDataUsers({
				...dataUsers,
				data: tmp as never,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const handleRefetch = async (currentPage = 0) => {
		try {
			const tmp =
				(await getUsers({
					like: dataUsers.valueOfFind,
					page: currentPage,
				}).unwrap()) || [];

			await refetchCountUsers();

			setDataUsers({
				...dataUsers,
				data: tmp as never,
			});
		} catch (error) {
			console.info(error);
		}
	};

	return (
		<LayoutMain isLoading={isLoadingCount || isLoadingUsers}>
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">PCRF Users Management</h1>
					</div>
				</div>
				{/* PCRF Users Management */}
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-person-lines-fill mr-3 float-left text-primary bi-2-5" />
								<h2 className="card-title">PCRF Users Management</h2>
								<p className="card-category">
									Management of Users of the PCRF GUI and API REST
								</p>
							</div>

							<div className="card-body">
								<div className="tabs-container mt-4">
									<Tabs
										activeKey={key}
										// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
										onSelect={k => setKey(k!)}
										id="uncontrolled-tab">
										<Tab
											eventKey="Search Profile"
											title={
												<>
													<RenderTabTitle
														active={key}
														isLoading={isLoadingUsers}
														title="Search Profile"
													/>

													<Form onSubmit={handleSubmit}>
														<div className="row">
															<div className="col-md-12 d-flex">
																<InputGroup className="mb-3">
																	<div style={{width: '35%'}}>
																		<Form.Select
																			className="rounded-left"
																			name="type_search"
																			aria-label="type_search"
																			value={dataUsers.type_search}
																			onChange={changeSelectOption}>
																			<option value="username">Username</option>
																			<option value="email">E-mail</option>
																		</Form.Select>
																	</div>
																	<Form.Control
																		type="text"
																		className="form-control"
																		placeholder="Search"
																		name="search"
																		defaultValue={''}
																		onChange={e =>
																			changeValueOfFind(e as never, 'profile')
																		}
																	/>
																	<Button
																		type="submit"
																		variant="secondary"
																		style={{color: 'white'}}>
																		Search
																	</Button>
																</InputGroup>
																<Button
																	onClick={() => navigate('/users/create')}
																	type="button"
																	variant="primary"
																	style={{color: 'white'}}>
																	Create
																</Button>
															</div>
														</div>
													</Form>
												</>
											}>
											{dataUsers.data ? (
												<TableUsers
													dataUsers={dataUsers.data as never}
													refetch={handleRefetch}
													isDisabled={false}
													pageCount={pageCount}
													onPageClick={handlePageClick}
												/>
											) : (
												<RenderNoData />
											)}
										</Tab>
									</Tabs>
								</div>
							</div>
							<div className="card-footer">
								<hr />
								<div className="stats">
									<i className="bi-1 bi-clock-history" /> Updated {timeStr}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LayoutMain>
	);
};

export default Users;
